import { render } from "./ProductOptionList.vue?vue&type=template&id=6358697c&scoped=true"
import script from "./ProductOptionList.vue?vue&type=script&lang=js"
export * from "./ProductOptionList.vue?vue&type=script&lang=js"

import "./ProductOptionList.vue?vue&type=style&index=0&id=6358697c&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6358697c"]])

export default __exports__